import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";

// @mui icons
import ChecklistIcon from "@mui/icons-material/Checklist";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import SignInIcon from "@mui/icons-material/Login";
import LogoutIcon from "@mui/icons-material/Home";
import Logout from "components2/f1/Logout";
import CryptoInsights from "components2/f1/CryptoInsights";
import Dashboard from "layouts/dashboard";
import WatchList from "components2/f2/WatchList";

const routes = [
  // {
  //   type: "collapse",
  //   name: "Dashboard",
  //   key: "dashboard",
  //   icon: <Icon fontSize="small">dashboard</Icon>,
  //   route: "/dashboard",
  //   component: <Dashboard />,
  // },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    type: "collapse",
    name: "Watch List",
    key: "watch-list",
    icon: <ChecklistIcon fontSize="small">watch list</ChecklistIcon>,
    route: "/watch-list",
    component: <WatchList />,
  },
  {
    type: "collapse",
    name: "Crypto Insights",
    key: "crypto-insights",
    icon: <AnalyticsIcon fontSize="small">crypto insights</AnalyticsIcon>,
    route: "/crypto-insights",
    component: <CryptoInsights />,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    showOnLogIn: false,
    dontShowOnLogIn: true,
    icon: <SignInIcon fontSize="small">login</SignInIcon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    dontShowOnLogIn: true,
    icon: <AppRegistrationIcon fontSize="small">assignment</AppRegistrationIcon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "Logout",
    key: "Logout",
    onlyLoggedIn: true,
    icon: <LogoutIcon fontSize="small">logout</LogoutIcon>,
    route: "/authentication/logout",
    component: <Logout />,
  },
];

export default routes;
